var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.392,
    height: 45.061,
    viewBox: "0 0 206.392 45.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.228,
    y1: -0.756,
    x2: 0.357,
    y2: 0.364,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#20434f",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#20434f",
    stopOpacity: 0.812
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#20434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20434f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.038,
    y1: 1,
    x2: 0.991,
    y2: 0.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#20434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20434f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.173,
    y1: 1.979,
    x2: 0.665,
    y2: 0.466,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#20434f",
    stopOpacity: 0.212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#20434f",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#20434f",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#20434f",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#20434f",
    stopOpacity: 0.965
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#20434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20434f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.992,
    x2: 0.038,
    y2: 0.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#20434f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#20434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20434f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opt_Logo_Gradient_petrol_rz_220126",
    transform: "translate(0 -0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80989",
    "data-name": "Pfad 80989",
    d: "M772.119,295.6",
    transform: "translate(-581.595 -264.884)",
    fill: "#d2e245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80990",
    "data-name": "Pfad 80990",
    d: "M80.613,284.224c-4.373-.252-3.959-6.136-3.552-7.741l3.185.644a8.078,8.078,0,0,0-.1,2.7,1.1,1.1,0,0,0,1.146.922c3.2-.18,6.265-2.11,10.124-4.365l1.148,2.391C89.858,280.958,83.816,284.741,80.613,284.224Z",
    transform: "translate(-68.625 -250.708)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80991",
    "data-name": "Pfad 80991",
    d: "M192.008,260.472a29.934,29.934,0,0,1-5.5.856c2.535-3.511,3.035-10.015-2.88-9.924-2.282-.019-5.092,1.5-8.822,4.735,1.481-6.184-3.79-7.43-8.079-4.349l1.179,2.48c.763-.264,3.309-1.917,3.321.369.058,1.948-1.4,4.251-2.855,7.367-4.332,4.641-7.758,8.08-8.377,12.5,0,1.781.85,2.752,2.307,2.752,1.5,0,2.711-1.214,3.52-2.59,2.55-4.209,4.654-7.972,6.191-11.169,2.46-2.5,8.29-8.146,10.521-8.256.769,0,1.133.486,1.133,1.417.1,3.689-5.062,7.612-8.457,5.3l-1.943,3.44c2.335,2.4,12.477.176,19.013-1.387",
    transform: "translate(-129.988 -231.368)",
    fill: "#20434f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80992",
    "data-name": "Pfad 80992",
    d: "M115.778,286.256",
    transform: "translate(-97.366 -257.991)",
    fill: "#d2e245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80993",
    "data-name": "Pfad 80993",
    d: "M62,192.563c-7.378,2.882-13.589,10.186-13.668,10.3l-2.769-2.067a37.154,37.154,0,0,1,14.521-12.189Z",
    transform: "translate(-45.563 -185.947)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80994",
    "data-name": "Pfad 80994",
    d: "M64.995,188.3c3.669-1.433,7.709-1.8,11.457.336,4.925,3.161,2.573,14.548.057,19.649-4.394,8.912-13.159,10.7-16.955,10a6.363,6.363,0,0,1-5.487-5.968c-.292-5.338,4.29-10.308,5.231-11.218L56,198.734c-6.922,6.965-10.4,21.649,3.08,23.956a22.038,22.038,0,0,0,21.645-11.641c3.245-5.909,7.334-20.809-1.669-26.336-5.043-3.237-10.712-2.687-15.835-.428Z",
    transform: "translate(-48.753 -181.604)",
    fill: "#20434f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80995",
    "data-name": "Pfad 80995",
    d: "M766.119,256.34",
    transform: "translate(-577.168 -235.92)",
    fill: "#d2e245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80996",
    "data-name": "Pfad 80996",
    d: "M328.765,263.1a6.528,6.528,0,0,1,.931-2.348c1.174-2.266,1.74-3.561,1.74-5.058,0-2.064-1.335-3.359-3.965-3.359-3.332-.167-7.3,2.233-15.378,8.863-.162,0-.162-.121-.162-.283a7.408,7.408,0,0,1,.838-2.772c.334-.728.976-1.48,1-2.137.133-1.517-1.674-2.283-3.213-1.816h0c-5.224,1.4-17.741,12.873-23.616,9.4,6.9-2.2,12.948-4.2,12.952-8.2,0-2.185-1.538-3.885-5.1-3.885-5.775,0-12.147,4.718-12.978,9.951a7.723,7.723,0,0,0,.273,3.546c.607,2.026,2.693,3.358,6.19,3.3,6.258.231,14.128-5.069,19.044-7.8-.6,2.686-.682,6.456,2.339,6.318a5.708,5.708,0,0,0,3.439-1.538c7.73-6.353,11.331-8.9,13.233-8.9,1,.11.131,1.085-.526,2.428-6.509,12.117,6.616,9.806,14.084,6.252l.288-4.515C337.662,261.831,329.014,265.46,328.765,263.1Zm-34.575-7.54c.526,0,.931.2.931.647,0,1.21-3.6,2.624-8.2,3.931A9.7,9.7,0,0,1,294.19,255.556Z",
    transform: "translate(-219.798 -232.355)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_1",
    "data-name": "Vereinigungsmenge 1",
    d: "M24.875,30.743c-3.283,0-5.5-.974-6.132-3.5a8.832,8.832,0,0,1,.288-4.515c2.081-5.759,4.687-8.5,8.713-13.662-11.6.042-19.76.583-27.37,1.249L0,6.156c8.042-.73,19.438-1.349,31.2-1.249C32.484,3.41,33.9,1.788,35.437,0L38.68,2.828c-.665.748-1.289,1.5-1.871,2.2,1.04.042,6.455.068,7.661.11L44.262,9.3c-2.537-.125-8.908-.193-10.863-.193-3.392,4.118-14.919,17.518-7.693,17.561h0c3.024,0,5.3-1.167,8.678-3.121h0c1.014-7.6,13.6-13.946,20.345-9.026L52.1,17.961c-4.236-3.258-13.294,1.636-13.148,6.1.591,3.305,8.387-1.59,11.448-4.931L53.88,21.28a12.722,12.722,0,0,0-.365,2.995.77.77,0,0,0,.7.892,7.226,7.226,0,0,0,3.235-1.523c1.046-.741,2.808-2.218,3.678-2.89a69.26,69.26,0,0,0,5.506-5.418c1.668-3.468,3.952-7.552,6.718-12.118.878-1.493,2.2-2.81,3.82-2.81,1.581,0,2.5,1.054,2.5,2.986-.6,4.36-3.54,7.662-9.089,13.567-1.581,3.381-3.048,5.357-2.985,7.47.024.816.439,1.123.983,1.174a5.925,5.925,0,0,0,2.518-.695c.751-.337,2.422-1.215,4.312-2.267a13.256,13.256,0,0,0,3.242-2.511l3.127-4.147c3.692-4.767,5.51-8.166,8.7-12.827l3.66,1.834c-1.482,2.558-2.5,4.182-4.767,7.7-1.82,2.985-5.128,6.757-7.566,10.466.046.431.525.152.926-.021,4.806-2.683,10.719-6.656,13.6-10.157l3.4,2.549c-2.1,2.549-5.382,5.059-9.874,7.81a2.659,2.659,0,0,0,2.625,2.251l-.1,4.135a6.519,6.519,0,0,1-6.617-3.959c-2.438,1.146-5.277,3.4-8.093,3.6a2.279,2.279,0,0,1-2.541-2.476c-1.025.632-5.814,3.2-7.716,2.932-3.548.089-4.672-3.351-3.82-6.5a34.441,34.441,0,0,1-5.549,4.25c-3.932,2.176-9.1,2.976-9.236-2.292-4.921,3.589-10.476,5.5-13.6,2.441h0c-3.708,1.912-6.179,3.016-10.345,3.016Z",
    transform: "translate(101.354 5.46)",
    fill: "#20434f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_80999",
    "data-name": "Pfad 80999",
    d: "M773.657,284.042c2.848.19,6.915-2.268,10.442-4.54l2.345,3.318c-3.874,2.71-8.663,5.231-12.649,5.375Z",
    transform: "translate(-580.051 -253.008)",
    fill: "url(#linear-gradient-4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGradient);
export default __webpack_public_path__ + "static/media/logoGradient.b6fce7bcde350287d74cbebd42bd4b49.svg";
export { ForwardRef as ReactComponent };